"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";
import { formatDateTime } from "@/utilities/formatting/date";
interface LivescoreDateNavProps {
  date: string; // ISO date string YYYY-MM-DD
  onChange: (date: string) => void;
}

/**
 * Returns a new ISO date string offset by `days` from the given date string.
 */
function offsetDate(isoDate: string, days: number): string {
  const d = new Date(isoDate);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}
export function LivescoreDateNav(t0) {
  const $ = _c(28);
  const {
    date,
    onChange
  } = t0;
  const inputRef = useRef(null);
  let t1;
  if ($[0] !== date || $[1] !== onChange) {
    t1 = () => onChange(offsetDate(date, -1));
    $[0] = date;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronLeft className="w-4 h-4" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <button onClick={t1} className="p-1.5 rounded-md hover:bg-muted transition-colors text-muted-foreground hover:text-foreground cursor-pointer" aria-label="Previous day">{t2}</button>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== date) {
    t4 = formatDateTime(new Date(date));
    $[6] = date;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-sm font-medium tabular-nums min-w-20 text-center">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => inputRef.current?.showPicker?.();
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <button onClick={t6} className="p-1.5 rounded-md hover:bg-muted transition-colors text-muted-foreground hover:text-foreground cursor-pointer" aria-label="Open calendar"><CalendarDays className="w-4 h-4" /></button>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onChange) {
    t8 = e => {
      if (e.target.value) {
        onChange(e.target.value);
      }
    };
    $[12] = onChange;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== date || $[15] !== t8) {
    t9 = <div className="relative">{t7}<input ref={inputRef} type="date" value={date} onChange={t8} className="absolute inset-0 opacity-0 w-0 h-0 pointer-events-none" tabIndex={-1} aria-hidden={true} /></div>;
    $[14] = date;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== date || $[18] !== onChange) {
    t10 = () => onChange(offsetDate(date, 1));
    $[17] = date;
    $[18] = onChange;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ChevronRight className="w-4 h-4" />;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10) {
    t12 = <button onClick={t10} className="p-1.5 rounded-md hover:bg-muted transition-colors text-muted-foreground hover:text-foreground cursor-pointer" aria-label="Next day">{t11}</button>;
    $[21] = t10;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t3 || $[25] !== t5 || $[26] !== t9) {
    t13 = <div className="flex items-center justify-center gap-2">{t3}{t5}{t9}{t12}</div>;
    $[23] = t12;
    $[24] = t3;
    $[25] = t5;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}